<template>
  <div class="page_maincontent main-container">
    <div class='top-content'>
      <h3>INVENTORY SEARCH</h3>
      <div class='row button-section mobile-full-width mobile-padding' v-if="!isMobile || !showFilter && isMobile">
        <div class="filter-left-col">
          <button v-if='salesClass === 0' v-bind:class='!filterModel.isUsed ? "button-yellow": "button-grey"'
            class="mobile-padding" @click='onNewFilter'
            v-bind:style="[filterModel.isUsed ? {'background-color':'#fff',  'color': '#000' } : borderStyle]">
            NEW
          </button>
          <button v-if='salesClass === 0' v-bind:class='filterModel.isUsed ? "button-yellow": "button-grey"'
            class="mobile-padding" @click='onUsedFilter'
            v-bind:style="[filterModel.isUsed ? borderStyle : {'background-color':'#fff',  'color': '#000' }]">
            USED
          </button>
        </div>

        <div class="filter-right-col">
          <button v-if="isMobile && !showFilter" class="button-grey filter-btn" @click='onMobileFilter'>
            Filter
          </button>
          <div class='filter-sort-cont'>
            <span class='desktop-only'>Sort by:</span>
            <select v-model="filterModel.sortBy" @change='onSortChange'>
              <option v-for="(opt, key) in sortOptions" :key='key' :value="opt.value">{{opt.text}}</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div v-if="showFilter" class='filterModel-сolumn mobile-full-width mobile-padding'>
        <InventoryFilterDynamic @search="onSearch()" :loading="!isLoaded" />
      </div>

      <div v-if='isLoaded && (!showFilter || !isMobile)' class='vehical-content-list mobile-full-width mobile-padding'>
        
        <specials-link :stylesObj="borderStyle"/>
        
        <div v-if="invetoryList && invetoryList.items.length > 0">
         
          <div v-for='(item)  in invetoryList.items' :key='item.id' class="inventory-list-item">
            <InventoryListItem :item="item" :borderStyle="borderStyle" />
          </div>

          <div class='padging-container' v-if='invetoryList.totalPages > 1'>
            <img src='../../assets/icons/black/rewind.png' v-if='invetoryList.pageNumber > 2' @click='onFirstPage' />
            <img src='../../assets/icons/black/back1.png' v-if='invetoryList.pageNumber != 1' @click='onPrevPage' />
            <span> {{invetoryList.pageNumber}} of {{invetoryList.totalPages}}</span>
            <img src='../../assets/icons/black/next1.png'
              v-if='invetoryList.totalPages != 1 && invetoryList.totalPages > 0 && filterModel.page != invetoryList.totalPages'
              @click='onNextPage' />
            <img src='../../assets/icons/black/fast-forward.png'
              v-if='invetoryList.totalPages != 1 && invetoryList.totalPages > 0  && filterModel.page != invetoryList.totalPages && filterModel.page !=  (invetoryList.totalPages - 1)'
              @click='onLastPage' />
          </div>
        </div>

        <div class='padging-container' v-if='invetoryList.totalPages == 0'>
          <span>NO RESULT</span>
        </div>
      </div>
      <div v-if="!isLoaded" class='loader-container' color="#f9f300">
        <loader :animation-duration="2500" :rhombus-size="25" color="#f9f300" />
      </div>
    </div>
  </div>
</template>

<script>
  import {
    mapState,
    mapActions,
    mapGetters
  } from 'vuex'
  import {
    LoopingRhombusesSpinner
  } from 'epic-spinners'
  import InventoryFilterDynamic from '@/components/inventory/vauto-filter'
  import InventoryListItem from '@/components/inventory/inventory-list-item'
  import {
    InventoryProviderType
  } from '@/shared/enums/inventory.js'
  import windowResizeMixin from '@/mixins/windowSize'
  import SpecialsLink from '@/components/inventory/specials-link'

  export default {
    name: 'vauto-content',
    components: {
      'specials-link': SpecialsLink,
      'loader': LoopingRhombusesSpinner,
      InventoryFilterDynamic,
      InventoryListItem
    },
    mixins: [windowResizeMixin],
    data () {
      return {
        isMobile: false,
        showFilter: false,
        isLoaded: false,
        sortOptions: [{
          value: 'make_asc',
          text: 'Make: A to Z'
        },
        {
          value: 'make_desc',
          text: 'Make: Z to A'
        },
        {
          value: 'price_desc',
          text: 'Price: Highest First'
        },
        {
          value: 'price_asc',
          text: 'Price: Lowest First'
        },
        {
          value: 'year_desc',
          text: 'Year: Highest First'
        },
        {
          value: 'year_asc',
          text: 'Year: Lowest First'
        },
        {
          value: 'added_asc',
          text: 'Date: Oldest First'
        },
        {
          value: 'added_desc',
          text: 'Date: Newest First'
        }
        ],
        providerType: InventoryProviderType
      }
    },
    mounted () {
      this.isLoaded = true
    },
    watch: {
      windowWidth () {
        if (this.currentWidth <= 1249) {
          this.showFilter = !!this.showFilter
          return (this.isMobile = true)
        } else {
          this.showFilter = true
          return (this.isMobile = false)
        }
      }
    },
    computed: {
      ...mapState({
        invetoryList: state => state.inventory.invetoryList,
        salesClass: state => state.common.salesClass,
        customization: state => state.common.customization,
        inventoryType: state => state.inventory.providerType
      }),
      ...mapGetters({
        filterModel: 'inventoryVautoFilter/getFilter'
      }),
      borderStyle: function () {
        var borderStyle = this.customization.borderOn ? 'solid 1px ' + this.customization.borderColor : 'none'
        var backgroundStyle = this.customization.mainColor
        var colorStyle = this.customization.fontColor
        return {
          border: borderStyle,
          background: backgroundStyle,
          color: colorStyle
        }
      }
    },
    methods: {
      ...mapActions({
        getVehiclesVauto: 'inventory/getVehiclesVauto',
        loadFilterData: 'inventoryVautoFilter/getFilterData',
        updateFilter: 'inventoryVautoFilter/updateFilter'
      }),
      async onNextPage () {
        this.isLoaded = false
        this.filterModel.page = this.invetoryList.pageNumber + 1
        await this.updateFilter(this.filterModel)
        await this.getVehiclesVauto(this.filterModel)
        this.isLoaded = true
      },
      async onFirstPage () {
        this.isLoaded = false
        this.filterModel.page = 1
        await this.updateFilter(this.filterModel)
        await this.getVehiclesVauto(this.filterModel)
        this.isLoaded = true
      },
      async onLastPage () {
        this.isLoaded = false
        this.filterModel.page = this.invetoryList.totalPages
        await this.updateFilter(this.filterModel)
        await this.getVehiclesVauto(this.filterModel)
        this.isLoaded = true
      },
      async onPrevPage () {
        this.isLoaded = false
        this.filterModel.page = this.invetoryList.pageNumber - 1
        await this.updateFilter(this.filterModel)
        await this.getVehiclesVauto(this.filterModel)
        this.isLoaded = true
      },
      async onSortChange () {
        this.isLoaded = false
        this.filterModel.page = 1
        await this.updateFilter(this.filterModel)
        await this.getVehiclesVauto(this.filterModel)
        this.isLoaded = true
      },
      async onUsedFilter () {
        this.isLoaded = false
        this.filterModel.isUsed = true
        this.filterModel.sortBy = 'price_asc'
        this.resetFilterModel()
        await this.updateFilter(this.filterModel)
        this.loadFilterData(this.filterModel)
        await this.getVehiclesVauto(this.filterModel)
        this.isLoaded = true
      },
      async onNewFilter () {
        this.isLoaded = false
        this.filterModel.isUsed = false
        this.filterModel.sortBy = 'added_asc'
        this.resetFilterModel()
        await this.updateFilter(this.filterModel)
        this.loadFilterData(this.filterModel)
        await this.getVehiclesVauto(this.filterModel)
        this.isLoaded = true
      },
      async resetFilterModel () {
        this.filterModel.modelId = null
        this.filterModel.brandId = null
        this.filterModel.trans = null
        this.filterModel.color = null
        this.filterModel.body = null
        this.filterModel.yearFrom = null
        this.filterModel.yearTo = null
        this.filterModel.priceFrom = null
        this.filterModel.priceTo = null
        this.filterModel.trim = null
        this.filterModel.page = 1
        this.filterModel.perPage = 12
        this.filterModel.sortBy = this.filterModel.isUsed ? 'price_asc' : 'added_asc'
        await this.updateFilter(this.filterModel)
      },
      async onSearch () {
        this.showFilter = !this.isMobile
        this.isLoaded = false
        await this.getVehiclesVauto(this.filterModel)
        this.isLoaded = true
      },
      onMobileFilter () {
        this.showFilter = true
      }
    }
  }
</script>

<style scoped>
  .main-container {
    max-width: 1280px;
    margin: 0 auto;
    padding-left: 25px;
    padding-right: 25px;
    height: 100%;
  }

  .mobile-only {
    display: none;
  }

  .filterModel-сolumn {
    width: 25%;

  }

  .vehical-content-list {
    flex: 1;
    padding-left: 60px;
    height: 670px;
    overflow: hidden;
    overflow-y: auto;
  }

  .inventory-list-item {
    margin-bottom: 20px;
  }

  .inventory-list-item:last-child {
    margin-bottom: 0;
  }

  .loader-container {
    flex: 1;
    text-align: center;
    padding-top: 15%;
  }

  .looping-rhombuses-spinner {
    display: inline-block;
  }

  .button-yellow,
  .button-grey {
    width: 30%;
    margin: 10px 0 0 0;
    font-weight: normal;
    text-align: center;
    cursor: pointer;
    font-size: 18px;
    background-color: #f9f301;
    color: #222222;
    border: none;
    height: 45px;
  }

  .button-grey {
    background-color: #EEEEEE;
  }

  .top-content {
    padding-top: 25px;
    margin-bottom: 20px;
  }

  .button-section {
    padding-top: 10px;
    align-items: flex-end;
    justify-content: flex-start;
  }

  .sort-section {
    width: 290px;
    display: inline-block;
    padding-left: 60px;
  }

  .sort-section span {
    font-weight: bold;
    font-size: 18px;
  }

  .button-section .button-yellow,
  .button-section .button-grey {
    width: 49%;
    font-size: 14px;
    font-weight: bold;
  }

  select {
    width: 100%;
    height: 35px;
    font-size: 18px;
    padding-left: 5px;
  }

  h5 {
    font-weight: bold;
    padding: 10px 0 10px 0;
  }

  .padging-container {
    text-align: center;
    padding: 25px;
  }

  .padging-container img {
    width: 25px;
    padding-left: 10px;
    padding-right: 10px;
    cursor: pointer;
  }

  .padging-container span {
    vertical-align: bottom;
    height: 31px;
    display: inline-block;
  }

  .filter-left-col{
    display: flex;
    flex-basis: 25%;
  }

  .filter-right-col{
    margin-left: 60px;
    display: flex;
  }

  @media screen and (max-width: 1249px) {
    .desktop-only{
      display: none;
    }

    .top-content {
      margin-bottom: 0;
      padding-top: 15px;
    }

    .top-content>h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      padding: 0;
    }

    .main-container {
      padding-left: 10px;
      padding-right: 10px;
    }

    .loader-container {
      width: 76%;
    }

    .filterModel-сolumn {
      padding: 0 10px;
    }

    .mobile-full-width {
      width: 100%
    }

    .mobile-padding {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }

    .filter-sort-cont {
      flex: 1;
      padding-left: 20px;
      margin-top: 10px;
    }

    select {
      height: 45px;
    }

    .mobile-only {
      display: inline-block;
    }

    .mobile-block {
      display: block;
    }

    .vehical-content-list {
      height: auto;
      overflow-y: hidden;
    }

    .sort-section {
      display: flex;
      margin-bottom: 15px;
    }

    .sort-section span {
      display: none;
    }
    .filter-left-col{
      flex-basis: 100%;
    }

    .filter-right-col{
      width: 100%;
      margin-left: 0px;
      margin-bottom: 10px;
    }
    .filter-right-col > .filter-btn{
      width: auto;
      flex-basis: 15%;
      min-width: 96px;
    }
  }
</style>



// WEBPACK FOOTER //
// vauto-content.vue?5faae9fe